import Cookies from 'js-cookie';

import { SPLIT_TEST_NAME } from './SPLIT_TESTS';
import { STEP_0_ELIGIBILITY_PREVIEW_COOKIE } from './step0PreviewCookie';
import { useAnonymousSplitTests } from './useAnonymousSplitTests';
import { useLocale } from '../hooks/useLocale';

export type TStep0EligibilityBranch = 'INCLUDE' | 'EXCLUDE' | undefined;

export function useStep0EligibilityTest(): {
  branch: TStep0EligibilityBranch;
  isInTest: boolean;
} {
  const { isUK } = useLocale();
  const isPreviewEnabled =
    Cookies.get(STEP_0_ELIGIBILITY_PREVIEW_COOKIE) === 'true';

  const splitTests = useAnonymousSplitTests({
    testFilter: SPLIT_TEST_NAME.NEW_CUSTOMERS_STEP_0_ELIGIBILITY_2026,
    // Previewers are kept unenrolled so internal traffic stays out of results.
    enabled: isUK && !isPreviewEnabled,
  });

  const branchName = splitTests?.[0]?.branch_name;
  const branch =
    branchName === 'INCLUDE' || branchName === 'EXCLUDE'
      ? branchName
      : undefined;

  return { branch, isInTest: isPreviewEnabled || branch === 'INCLUDE' };
}

export function useIsInStep0EligibilityTest(): boolean {
  return useStep0EligibilityTest().isInTest;
}
